var map = {
	"./BOOST.svg": 2357,
	"./GRAB.svg": 2358,
	"./MBB.svg": 2359,
	"./TNG.svg": 2360,
	"./direpay.svg": 2361,
	"./doitnow.svg": 2362,
	"./duitnow.svg": 2363,
	"./fpay.svg": 2364,
	"./fpay2.svg": 2365,
	"./fpx.svg": 2366,
	"./online_banking.svg": 2367,
	"./rapidpays.svg": 2368,
	"./secret_pay.svg": 2369,
	"./secret_pay_offline.svg": 2370,
	"./secret_pay_pro.svg": 2371,
	"./secret_pay_pro_b.svg": 2372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;